import DashboardTilesModule from './DashboardTiles.module';

export default DashboardTilesModule;
